module.exports = __webpack_public_path__ + "static/media/incoming-call.cd7290d1.svg";